import PageCommon from "./PageCommon.js";

import Appear from "./classes/Appear.js";

export default class PageProductList extends PageCommon {
	constructor() {
		super();
		this.filterNames = ["uidmc", "uidc", "uidb", "uidtv", "uidtp", "c", "p"];
	}
	init($data) {
		super.init($data);
		//this.showPreloader(false); 
		//
		this.bindEvents();
		this.setPlugins();
		this.colorlink();
		this.setupMenu();

		this.appear = new Appear();
		this.appear.init();

		//
		this.data = $data;
		//alert(this.data.NeutralTitle)
		//
		this.setup(false);
		this.showPreloader(false);
		//
		// dispaccio un evento globale
		this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
	}

	setup(bPaintMenu) {
		if (bPaintMenu) {
			// prima la url
			let split = StateManager._splitUrl(document.location.href);
			let query = this.data.rs.query;
			for (let k of this.filterNames) {
				if (query[k].length == 0) delete split.qPart[k];
				else split.qPart[k] = query[k].join(",");
			}
			let u = StateManager._mergeUrl(split, false);
			window.history.replaceState(window.history.state, document.title, u);
			// i filtri sopra e i check
			$("input[type='checkbox']").prop("checked", false);
			$(".tag", $(".tag-list")).remove();
			let tmplate = $("#template_tag");
			for (let f of this.data.rs.active_filters) {
				let mc = tmplate.clone();
				mc.attr("id");
				$("button", mc).data("name", f.Name);
				$("button", mc).data("value", f.Value);
				$("span", mc).html(f.Label);
				$(".tag-list").append(mc);
				//
				$("input[type='checkbox'][value=\"" + f.Value + '"]').prop("checked", true);
			}
			// i dasablitati value="ZAHEL" name="uidb"
			$("input[type='checkbox'][name='uidb']").prop("disabled", true);
			for (let o of this.data.rs.brand_options_list) $("input[type='checkbox'][value=\"" + o.Value + '"]').prop("disabled", false);
			$("input[type='checkbox'][name='uidc']").prop("disabled", true);
			for (let o of this.data.rs.paesi_options_list) $("input[type='checkbox'][value=\"" + o.Value + '"]').prop("disabled", false);
		}
		//
		if (this.data.rs.active_filters.length > 0) {
			PageCommon.disable($(".btn-reset"), false, 1);
		} else {
			PageCommon.disable($(".btn-reset"), true, 0.5);
		}
		$(".btn-reset").off("click");
		$(".btn-reset").on("click", this.onResetFilterAll.bind(this));
		//
		$(".remove-btn").off("click");
		$(".remove-btn").on("click", this.onResetFilter.bind(this));
		//
		$("input[type=checkbox]").off("click");
		$("input[type=checkbox]").on("click", this.onChangeCheck.bind(this));
	}

	onResetFilterAll() {
		$(".remove-btn[data-value]").parent().remove();
		$("input[type='checkbox']").prop("checked", false);
		// make call
		let query = $.extend({}, this.data.rs.query);
		for (let k of this.filterNames) query[k] = [];
		this.makeTheCall(query);
	}
	onResetFilter(ev) {
		let Name = $(ev.currentTarget).data("name");
		let Value = $(ev.currentTarget).data("value") + "";
		$(ev.currentTarget).parent().remove();
		$("input[type='checkbox'][value=\"" + Value + '"]').prop("checked", false);
		// make call
		let query = $.extend({}, this.data.rs.query);
		let idx = query[Name].indexOf(Value);
		if (idx != -1) query[Name].splice(idx, 1);
		this.makeTheCall(query);
	}
	onChangeCheck(ev) {
		let Name = $(ev.currentTarget).attr("name");
		let Value = $(ev.currentTarget).attr("value") + "";
		let checked = $(ev.currentTarget).prop("checked");
		if (!checked)
			$('.remove-btn[data-value="' + Value + '"]')
				.parent()
				.remove();
		// make call
		let query = $.extend({}, this.data.rs.query);
		let idx = query[Name].indexOf(Value);
		if (!checked) {
			if (idx != -1) query[Name].splice(idx, 1);
		} else {
			if (idx == -1) query[Name].push(Value);
		}
		this.makeTheCall(query);
	}

	makeTheCall(query) {
		this.showPreloader(true);
		this.appear.resetAnimations();
		thatServiceManeger.standardCall("/api/ei/doproductlist", { search: query }, this.onCallHandler.bind(this));
	}

	onCallHandler(rs) {
		if (rs.Success) {
			this.data.rs = rs;
		}
		//console.log(">>>"+rs.Success)
		this.setup(true);
		this.showResults(this.data.rs);
		document.title = this.data.NeutralTitle;
		this.showPreloader(false);
	}

	//////////////////////////////////

	showResults(rs) {
		window.scroll({
			top: 0,
			left: 0,
			behavior: "smooth",
		});
		// rs.MacroCategoria
		// rs.Paesi
		$(".blocco-pieno").remove();
		// console.log(rs.Paesi.length)
		if (rs.Paesi.length == 0) {
			$(".blocco-vuoto").show();
			return;
		}
		// TODO ALE
		// OK RISULTATI
		$(".blocco-vuoto").hide();
		console.log(rs);
		this.renderResults(rs);
		this.bindEvents();
		this.setPlugins();
	}

	renderResults(rs) {
		const resultsList = document.querySelector(".blocco-risultati");
		rs.Paesi.map((result, index) => {
			const accordionFilter = "accordion-filter" + index + result.Uid;
			const filter = "filter" + index + result.Uid;
			const country = "country" + result.Uid;
			const countryElement = document.querySelector(".library #template_country").cloneNode(true);
			countryElement.id = country;
			countryElement.classList.add("blocco-pieno");
			const countryWrapper = countryElement.querySelector(".country-wrapper");
			if (rs.MacroCategoria && index === 0) {
				const countryFocusElement = document.querySelector(".library #template_focus").cloneNode(true);
				countryFocusElement.id = "#focusCountry";
				countryFocusElement.querySelector("h3").innerHTML = rs.MacroCategoria.Label;
				countryFocusElement.querySelector(".focus-descr-short").innerHTML = rs.MacroCategoria.DescriptionShort;
				if (!rs.MacroCategoria.Description) {
					countryFocusElement.querySelector("a.js-toggle-class").remove();
				} else {
					countryFocusElement.querySelector(".focus-descr").innerHTML = rs.MacroCategoria.Description;
				}
				countryWrapper.prepend(countryFocusElement);
			}
			countryElement.querySelector(".country-result").id = accordionFilter;
			countryElement.querySelector(".country-header .text-primary a").innerHTML = result.Label;
			countryElement.querySelector(".country-header .text-primary a").dataset.target = "#" + filter;
			countryElement.querySelector(".country-header button").dataset.target = "#" + filter;
			const countryBody = countryElement.querySelector(".country-body");
			countryBody.dataset.parent = "#" + accordionFilter;
			countryBody.id = filter;
			countryBody.querySelector(".country-descr p").innerHTML = result.Description ? result.Description : index === 0 && rs.MacroCategoria?.Description ? rs.MacroCategoria?.Description : "";
			result.Brands.map((brand, counter) => {
				const marker = "m" + index + counter;
				const brandElement = document.querySelector(".library #template_brand").cloneNode(true);
				brandElement.id = "";
				brandElement.querySelector("h2 a").href = brand.PageUrl;
				brandElement.querySelector("h2 a").innerHTML = brand.Label;
				brandElement.querySelector(".swiper-navigation .btn-prev").classList.add(marker + "-prev");
				brandElement.querySelector(".swiper-navigation .btn-next").classList.add(marker + "-next");
				brandElement.querySelector(".swiper-container").dataset.name = marker;
				const swiperWrapper = brandElement.querySelector(".swiper-wrapper");
				brand.Articles.map((product) => {
					const swiperElement = document.querySelector(".library #template_swiper").cloneNode(true);
					swiperElement.id = "";
					swiperElement.querySelector(".product-preview").href = product.PageUrl;
					swiperElement.querySelector("img").src = product.ImageUrl;
					swiperElement.querySelector("img").alt = product.Label;
					swiperElement.querySelector("p").innerHTML = product.Label;
					swiperElement.querySelector("h3").innerHTML = product.SubLabelToTitleCase;
					swiperWrapper.appendChild(swiperElement);
				});
				countryBody.appendChild(brandElement);
			});
			resultsList.appendChild(countryElement);
		});
	}
}
